export default {
  // Encabezado y estado de la ocurrencia
  labels: {
    location: 'Ubicación',
    open_from: 'Abierto desde',
    close_until: 'Cierra hasta el',
    score: 'Puntaje total',
    execution_time: 'Tiempo de ejecución',
    first_signature_warning: 'Aún no has agregado ninguna firma.',
    second_signature_warning: 'Aún no has agregado ninguna firma adicional.',
    additional_signature_warning: 'Para finalizar la auditoría se requieren todas las firmas adicionales obligatorias.',
    signature_warning_title: 'Cuidado!',
    signature_capture_title: 'Captura de firmas',
    signature_full_name: 'Nombre completo',
    ok: 'OK',
    mifel_logic_applied: "LÓGICA MIFEL APLICADA - Form ID: {form_id} {'|'} Org ID: {org_id}",
    critical_point: 'Punto crítico',
    excel_answer_header: 'Respuesta',
    excel_column_header: 'Col {n}',
    excel_table_label: 'Tabla:',
    excel_answer_yes: 'Si',
    completed: 'Completado',
    final_result: 'Resultado'
  },

  // Botones de la pantalla de la ocurrencia
  actions: {
    finish: 'Finalizar',
    send_to_authorization: 'Enviar a Autorización',
    authorize: 'Autorizar Formulario',
    complete_form: 'Completar formulario',
    print: 'Imprimir',
    email: 'Correo',
    excel: 'Excel',
    pdf: 'PDF',
    add_signature: 'Agregar firma',
    signature_clear: 'Reiniciar',
    signature_save: 'Guardar firma'
  },

  // Diálogos y avisos al llenar, finalizar y autorizar
  messages: {
    alert_title: 'Alerta',
    finish_confirm: 'Una vez finalizado el formulario, no se podrán cambiar respuestas ni agregar firmas.',
    send_by_mail: 'El formulario se finalizó correctamente, ¿Desea enviarlo por correo?',
    uncompleted_tasks_title: 'Tareas sin completar',
    uncompleted_tasks: 'Asigna prioridad, fecha y usuario responsable para poder terminar el formulario',
    resyncing_answers: 'Re-sincronizando respuestas...',
    sync_missing_title: 'Faltan elementos por sincronizar',
    sync_missing_answers: 'Sin responder:',
    sync_missing_addons: 'Elementos faltantes:',
    sync_missing_addon: 'Falta {type} en "{title}"',
    validation_table_empty: 'La tabla : {name} se encuentra vacía. Por favor, llene los campos vacíos.',
    validation_table_empty_cells: 'Existen campos vacíos en : {name}. Por favor, llene los campos vacíos.',
    validation_footer: 'Responde los items faltantes y vuelve a intentar',
    no_group: 'Sin grupo',
    unnamed_item: 'Item sin nombre',
    item_id: 'ID {id}',
    addon_comment: 'Comentario',
    addon_picture: 'Imagen',
    addon_document: 'Documento',
    syncing_offline_answers: 'Sincronizando respuestas offline...',
    offline_answers_synced: 'Respuestas offline sincronizadas correctamente',
    authorizing: 'Autorizando formulario...',
    authorized: 'Formulario autorizado exitosamente',
    deadline_active: '⚠️ Este formulario tiene un límite de tiempo activo',
    deadline_due: 'Debe ser completado antes de: {date}',
    understood: 'Entendido',
    na_group_title: 'Marcar grupo como NA',
    na_group_confirm: 'Todas las respuestas de «{group}» se marcarán como NA, también las que ya estaban contestadas. ¿Desea continuar?',
    send_by_email_title: 'Enviar formulario por correo',
    send_by_email_label: 'Escribe uno o más e-mails',
    send_by_email_ok: 'Enviar',
    reset_answers_confirm: 'Se borrarán de forma permanente las respuestas ingresadas hasta este momento.',
    answers_sent: 'Las respuestas fueron enviadas',
    connection_lost: 'Se perdió la conexión a internet, guardando respuestas en modo fuera de línea.',
    connection_restored: 'Se ha recuperado la conexión a internet.'
  },

  // Resultado de autoevaluación (badges/reporte)
  self_evaluation_result: {
    low: 'Bajo',
    marginal: 'Marginal',
    standard: 'Estándar',
    food_security: 'Seguridad de alimentos',
    local_standards: 'Estándares locales',
    brand_standards: 'Estándares de marca',
    final: 'Resultado'
  },

  // Generación y descarga del PDF de la ocurrencia
  pdf: {
    generating: 'Generando PDF...',
    taking_long: 'El PDF está tardando más de lo normal. Te avisaremos en tus notificaciones cuando esté listo.',
    ready_in_notifications: 'Tu PDF ya está listo. Lo encontrarás en tus notificaciones.',
    downloaded: 'Tu PDF se descargó.',
    generate_error: 'No pudimos generar el PDF. Intenta de nuevo.',
    retry: 'Reintentar',
    back: 'Volver',
    downloading_title: 'Descargando tu archivo...',
    downloading_subtitle: 'Esto puede tardar unos segundos.',
    done_title: 'Descarga lista',
    done_subtitle: 'Revisa tus archivos descargados.',
    error_title: 'No pudimos descargar el archivo',
    error_subtitle: 'El enlace pudo haber expirado. Solicita el archivo de nuevo.'
  },

  // Tareas vinculadas de la ocurrencia
  tasks: {
    edit_title: 'Editar Titulo',
    priority: 'Prioridad',
    days: 'dias',
    assigned_to: 'Asignada a',
    user: 'Usuario',
    category: 'Categoria',
    end_date: 'Fecha limite',
    area: 'Área',
    hierarchy_optional: 'Jerarquía (Opcional)',
    enforce_evidence: 'Imagen requerida',
    assigned_task: 'Tarea asignada',
    overdue_task: 'Tarea vencida',
    pending_tasks: 'Tareas pendientes',
    action_plan: 'Plan de acción',
    delete_confirm_title: 'Confirmación',
    delete_confirm: '¿Desea borrar la tarea?',
    changes_saved: 'Cambios guardados',
    assigned_by: 'Asignado por',
    assigned_to_label: 'Asignado a'
  },

  // Lista de preguntas del llenado y sus complementos
  items: {
    campaign_points_hint: 'Esta pregunta cuenta para puntos de campaña.',
    camera_only: 'Solo se permite captura con cámara.',
    watch_video: 'Ver video',
    delete_item_title: 'Advertencia: Acción Irreversible',
    delete_item_confirm: "¿Está seguro de eliminar '{name}' y todo su contenido?"
  },

  // Campos de respuesta por tipo de pregunta (Field*)
  fields: {
    total: 'Total',
    totals_not_configured: 'No se configuraron los totales',
    updating: 'Actualizando...',
    check_in: 'Check In',
    previous_reading: 'Lectura anterior',
    current_reading: 'Lectura actual',
    difference: 'Diferencia',
    document_approved: 'Documento aprobado',
    document_rejected: 'Documento rechazado',
    document_saved: 'El documento se guardó correctamente.',
    document_deleted: 'Eliminación exitosa',
    default_document_name: 'documento',
    analyzing_image: 'Analizando imagen'
  }
}
